<template>
  <div>
    <div class="TianYuanfirst">
      <div class="title_box">
        <!-- <div class="en">PRODUCT SELLING POINT</div> -->
        <div class="en">{{enName}}</div>
        <!-- <div class="zh">天原PVC-0管</div> -->
        <div class="zh">{{name}}</div>
        <div class="line"></div>
      </div>
      <swiper
        :options="swiperOptions"
        ref="mySwiper"
        style="width: 100%; height: 100%"
        v-if="arr.length"
      >
        <swiper-slide
          v-for="(item, index) in arr"
          :key="index"
          style="width: 100%; height: 100%"
        >
          <!-- <el-image :src="item.img" style="height: 100%" fit="fit"></el-image> -->
          <img :src="item" class="img_cover" alt="" />
        </swiper-slide>
        <div class="pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    obj: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          //分页容器的css选择器
          el: ".pagination",
          clickable: true,
          renderBullet: function (index, className) {
            var text = "";
            switch (index) {
              case 0:
                text = "";
                break;
              case 1:
                text = "";
                break;
              case 2:
                text = "";
                break;
            }
            return '<li class="' + className + '">' + text + "</li>";
          },
        },
      },
      name:'',
      arr: [] || this.obj.selling_image,
      enName:'',
    };
  },
  watch: {
    obj(val) {
      this.enName = val.name_en
      this.name = val.name
      this.arr = val.selling_image;
    },
  },
};
</script>

<style scoped lang='scss'>
.TianYuanfirst {
  width: 100%;
  height: 100vh;
  position: relative;
  .title_box {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 16vh;
    z-index: 9;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 67px;
      text-align: center;
      color: rgba(255, 255, 255, 0.1);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 58px;
      color: #ffffff;
      text-align: center;
      width: 100%;
      margin-top: -40px;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
}
</style>